import { Component, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { filter, pairwise } from 'rxjs/operators';
import { SearchEngineService } from '../../../core/services/search-engine.service';
import { SharedContainer } from '../../../shared/shared.container';


@Component({
    selector: 'app-getstarted',
    templateUrl: './getstarted.component.html',
    styleUrls: ['./getstarted.component.scss'],
})

export class GetStartedComponent implements AfterViewInit, OnDestroy {

    alive: boolean;
    result: string;
    currentPage = 0;

    deviceType: any;

    constructor(private router: Router, private angulartics2: Angulartics2, private searchService: SearchEngineService,
        private deviceInfo: DeviceDetectorService, private sharedContainer: SharedContainer) {
        this.searchService.getTravellerLocation().subscribe(response => {
            this.searchService.getCountry(response.ip).subscribe(responsee => {
                this.sharedContainer.userCountry = responsee.country_name;
            });
        });
        if (this.deviceInfo.isDesktop()) {
            this.deviceType = 'desktop';
            this.sharedContainer.deviceType = this.deviceType;
        } else if (this.deviceInfo.isMobile()) {
            this.deviceType = 'mobile';
            this.sharedContainer.deviceType = this.deviceType;
        } else if (this.deviceInfo.isTablet()) {
            this.deviceType = 'tablet';
            this.sharedContainer.deviceType = this.deviceType;
        }
    }

    ngAfterViewInit() {
        if (this.deviceType === 'mobile') {
            this.handleSlide();
            const dot = <HTMLElement>document.getElementById('page' + this.currentPage);
            dot.classList.remove('hidden');
        }
        this.router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {
                if (events[1].urlAfterRedirects === '/404') {
                    this.angulartics2.eventTrack.next({ action: '404 from ' + events[0].urlAfterRedirects });
                    console.log('previous url', events[0].urlAfterRedirects);
                    console.log('current url', events[1].urlAfterRedirects);
                }
            });
        this.alive = true;
    }

    ngOnDestroy() {
        this.alive = false;
        this.currentPage = 0;
        const cvBanner = <HTMLElement>document.getElementById('covid-banner');
        if (cvBanner) {
            cvBanner.remove();
        }
    }

    onSwipeRight(event) {
        if (event.offsetDirection === 4) {
            this.nextSlide('right');
        } else {
            this.nextSlide('left');
        }
    }

    handleSlide() {

        const sliderElem = document.querySelector('.slider');
        const dotElems = sliderElem.querySelectorAll('.slider__dot');
        const indicatorElem = sliderElem.querySelector('.slider__indicator');

        Array.prototype.forEach.call(dotElems, (dotElem) => {

            dotElem.addEventListener('click', () => {

                const currentPos = parseInt(sliderElem.getAttribute('data-pos'), 10);
                const newPos = parseInt(dotElem.getAttribute('data-pos'), 10);

                const newDirection = (newPos > currentPos ? 'right' : 'left');
                const currentDirection = (newPos < currentPos ? 'right' : 'left');

                indicatorElem.classList.remove(`slider__indicator--${currentDirection}`);
                indicatorElem.classList.add(`slider__indicator--${newDirection}`);
                sliderElem.setAttribute('data-pos', newPos.toString());

                this.currentPage = newPos;

                if (this.currentPage === 2) {
                    this.createRequest();
                    return;
                }

                this.angulartics2.eventTrack.next({ action: 'SwipedToPage ' + this.currentPage + ' mobile' });

            });

        });

    }

    nextSlide(gesture) {

        const page0 = <HTMLElement>document.getElementById('page0');
        const page1 = <HTMLElement>document.getElementById('page1');
        const page2 = <HTMLElement>document.getElementById('page2');

        if (gesture === 'left' && this.currentPage <= 1) {
            if (this.currentPage === 0) {
                page0.classList.add('hidden');
                page1.classList.remove('hidden');
            } else if (this.currentPage === 1) {
                page1.classList.add('hidden');
                page2.classList.remove('hidden');
            }
            const dot = <HTMLElement>document.getElementById('page' + ++this.currentPage);
            dot.click();
        } else if (gesture === 'right' && this.currentPage > 0) {
            if (gesture === 'right' && this.currentPage >= 0) {
                if (this.currentPage === 2) {
                    page2.classList.add('hidden');
                    page1.classList.remove('hidden');
                } else if (this.currentPage === 1) {
                    page1.classList.add('hidden');
                    page0.classList.remove('hidden');
                }
                const dot = <HTMLElement>document.getElementById('page' + --this.currentPage);
                dot.click();
            }
        }

    }

    createRequest() {
        this.angulartics2.eventTrack.next({ action: 'SearchFromRoot' });
        this.router.navigate(['search/']);
    }

}
